var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mx-0 row-image",style:({'height': `${_vm.is_small?12:20}0px`}),attrs:{"justify":"center","align":"center"}},[_c('v-img',{class:{'separate' : !_vm.is_small},attrs:{"src":"https://s3-us-west-2.amazonaws.com/cdn-yeeko/static/img/logo.png","alt":"Logo Yeeko","height":"60","contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }